import { Component, Input, SimpleChanges } from '@angular/core';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { ReportRetailDetailService } from './retail-property-detail.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { retailsPropertyDetailMenuEnum } from './retail-property-detail.enum';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';
import { RetailPropertyDetailConstant } from './retail-property-detail.constant';
import { Subscription } from 'rxjs';
import { ReportPropertyDetailService } from '../residential-property/residential-property-detail.service';
import { PropertyCategoryEnum } from '../../propertyCategory.enum';

@Component({
  selector: 'app-retail-property-detail',
  templateUrl: './retail-property-detail.component.html',
  styleUrls: ['./retail-property-detail.component.scss']
})
export class RetailPropertyDetailComponent {

  @Input() propertyInfo: any;
  propertyDetail: any = null;
  currentReportView: number = ReportsViewEnum.mapView;
  propertyCategory = PropertyCategoryEnum;

  currentScroll: any = retailsPropertyDetailMenuEnum.overview;

  retailUnitLoading: boolean = false;
  
  retailsPropertyDetailMenuEnum = retailsPropertyDetailMenuEnum;
  reportName: string = '';
  currentLang: string = '';
  languageSub$: Subscription = new Subscription();
  currentReportView$: Subscription = new Subscription();
  overViewMenu = RetailPropertyDetailConstant.overViewMenu;
  showOfficeRent = true;

  constructor(
    private sharedService: SharedService,
    private reportRetailDetailService: ReportRetailDetailService,
    public reportService: ReportService,
    private reportPropertyDetailService : ReportPropertyDetailService

  ) { }

  ngOnInit(): void {
    this.setLang();
    this.getReportView();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.reportPropertyDetailService.propertyInfo = this.propertyInfo;
    this.reportRetailDetailService.propertyInfo = this.propertyInfo;
    this.reportRetailDetailService.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.reportRetailDetailService.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.reportRetailDetailService.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
    this.scrollPoint(String(this.retailsPropertyDetailMenuEnum.overview));
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scrollPoint(String(this.retailsPropertyDetailMenuEnum.overview));
    }, 0);
  }

  setLang(): void {
    this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.currentLang = lang;
    })
  }

  getReportView() {
    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      this.currentReportView = view;
    });
  }

  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }

  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }

  backToTransaction() {
    if(!this.reportService.projectReportView){
       this.reportService.isDetailPageOpen = false;
    }  
    // this.reportService.isDetailPageOpen = false;
    this.reportService.transactionPropertyDetails.next(false);
  }

  officeRentSec(e: any){
      this.showOfficeRent = e;
      if(!this.showOfficeRent){
        this.overViewMenu = this.overViewMenu.filter(x => x.name !== retailsPropertyDetailMenuEnum.officeRentalUnitSizeWise);
      }
    }
  ngOnDestroy(): void {
    this.reportRetailDetailService.propertyInfo = null;
    this.languageSub$?.unsubscribe()
    this.currentReportView$?.unsubscribe()
  }

}
